/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Typography from '@digital-hig/mui/dist/Typography';
import ListCTA from './listCTA';
import StatusButton from '../common/statusButton';
import {
  styleVariables,
} from '../common/constants';

const ThinHeader = ({
  thinHeaderRef, isVisible, data, isCompleted, isStarted, analyticsArea,
}) => {
  const titleRef = useRef(null);

  return (
    <ThinHeaderElement ref={thinHeaderRef} id="thin-header">
      {isVisible && (
        <Grid className="thin-header-container">
          <Grid container className="header-container maxWidth" alignItems="center" justifyContent="space-between">
            <Grid xs={12} md={7} lg={8}>
              <Typography ref={titleRef} className="m-title" component="h3" variant="headline-small">{data.title}</Typography>
            </Grid>
            <Grid xs={12} md={5} lg={4} className="actions">
              <StatusButton hasCompleted={isCompleted} hasStarted={isStarted} courseData={data} moduleData={data} />
              <ListCTA data={data} analyticsArea={analyticsArea} />
            </Grid>
          </Grid>
        </Grid>
      )}
    </ThinHeaderElement>
  );
};

const ThinHeaderElement = styled.div`
    position: sticky;
    top: 0;
    z-index: 99;
.thin-header-container{
    background-color: ${styleVariables.backgroundPanelColor};
    margin:0;
    width:100%;
    box-shadow: inset 0 -1px 0 0 #808080;
    padding-top: 21px;
    padding-bottom: 21px;

    .header-container {
      margin: 0 auto; 
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }

    @media screen and (max-width: 560px) {
      .m-title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-right: 16px;
      }
      .actions {
        display: flex;
        justify-content: space-between;
        padding-right: 16px;
        margin-top : 16px;
        
        .listCTA {
          flex: 1;
        }
      }
      
    }
  }

  @media only screen and (max-width: 559px) {
    .thin-header-container{
      padding-left: 1rem;
      padding-right: 1rem;
    }
    
  }
  @media only screen and (min-width: 560px) and (max-width: 1039px) {
    .thin-header-container{
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
  @media only screen and (min-width: 1040px) {
    .thin-header-container{
      padding-left: 5%;
      padding-right: 5%;
    }
  }
`;

ThinHeader.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  thinHeaderRef: PropTypes.shape({ current: PropTypes.shape({ offsetWidth: PropTypes.number }) }),
  isVisible: PropTypes.bool,
  isCompleted: PropTypes.string.isRequired,
  isStarted: PropTypes.string.isRequired,
  analyticsArea: PropTypes.string,
};

ThinHeader.defaultProps = {
  thinHeaderRef: null,
  isVisible: false,
  analyticsArea: 'undefined',
};

export default React.memo(ThinHeader);
